module.exports = __webpack_public_path__ + "img/電気回路_4_8_1.5f9734a1.png";